import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreActions: {
		id: 'dashboard-edit.gadget-editable.config-dropdown.more-actions',
		defaultMessage: 'More actions for {gadgetTitle} gadget',
		description: 'Accessible button label for the more actions dropdown menu for a gadget',
	},
	expand: {
		id: 'dashboard-edit.gadget-editable.config-dropdown.expand',
		defaultMessage: 'Expand',
		description: 'expand gadget',
	},
	maximize: {
		id: 'dashboard-edit.gadget-editable.config-dropdown.maximize',
		defaultMessage: 'Maximize',
		description: 'maximize gadget',
	},
	restore: {
		id: 'dashboard-edit.gadget-editable.config-dropdown.restore',
		defaultMessage: 'Restore',
		description: 'restore gadget',
	},
	delete: {
		id: 'dashboard-edit.gadget-editable.config-dropdown.delete',
		defaultMessage: 'Delete',
		description: 'delete gadget',
	},
	configure: {
		id: 'dashboard-edit.gadget-editable.config-dropdown.configure',
		defaultMessage: 'Configure',
		description: 'configure gadget',
	},
	rename: {
		id: 'dashboard-edit.gadget-editable.config-dropdown.rename',
		defaultMessage: 'Rename',
		description: 'Rename gadget',
	},
	duplicate: {
		id: 'dashboard-edit.gadget-editable.config-dropdown.duplicate',
		defaultMessage: 'Duplicate',
		description:
			'This label is for a button that allows the user to duplicate a gadget on a dashboard, copying over all settings',
	},
	colorHeading: {
		id: 'dashboard-edit.gadget-editable.config-dropdown.color-heading',
		defaultMessage: 'Highlight color',
		description: 'gadget color heading',
	},
});
